import { CustomAnswerModel } from '../models/comparison/comparison-answers';
import { AnswerService } from './answer/answer.service';
import { FormArray } from '@angular/forms';
import { Injectable } from '@angular/core';
import { FormService } from './form.service';
import { FormBuilderService } from './form-builder.service';

@Injectable()
// This service handle CRUD of additional profiles
export class FormProfilesService {
    constructor(private formService: FormService,
        private formBuilderService: FormBuilderService,
        private answerService: AnswerService) { }

    public addProfile(form: FormArray, index: number): void {
        const personalArray = this.formService.form.get('profiles') as FormArray;
        personalArray.setControl(index, form);
        this.answerService.answerSetModel.profileAnswers[+index] = this.getAnswers(form);
        this.answerService.emitChange();
    }

    public applyMainProfile(form: FormArray) {
        const personalArray = this.formService.form.get('profiles') as FormArray;
        if (personalArray.get(`0`)) {
            (personalArray as FormArray).setControl(0, form);
            this.answerService.answerSetModel.profileAnswers[0] = this.getAnswers(form);
            this.answerService.emitChange();
        }
    }

    public editProfile(form: FormArray, index: number): void {
        const personalArray = this.formService.form.get('profiles') as FormArray;
        if (personalArray.get(`${index}`)) {
            personalArray.setControl(index, form);
            this.answerService.answerSetModel.profileAnswers[+index] = this.getAnswers(form);
        }

    }

    public deleteProfile(index: number): void {
        const personalArray = this.formService.form.get('profiles') as FormArray;
        if (personalArray.get(`${index}`).value) {
            personalArray.removeAt(index);
            this.answerService.answerSetModel.profileAnswers.splice(+index, 1);
        }
    }

    private getAnswers(formArray: FormArray): CustomAnswerModel[] {
        return formArray.value.map(questionValue => {
            const answer = new CustomAnswerModel({
                type: questionValue.question.type,
                specification: questionValue.question.specification,
                questionId: questionValue.questionId
            });
            this.formBuilderService.setAnswer(questionValue.answers, answer);
            return answer;
        });
    }
}
